import plagResult from './DocumentResult/PlagiarismResult'
import spellingResult from './DocumentResult/SpellingResult'

const documentResult = {
    namespaced: true,
    modules: {
        plagiarism: plagResult,
        spelling: spellingResult
    },
    state: {
        documentResultMode: '',
        documentInfoCurrent: {}
    },
    mutations: {
        UPDATE_DOCUMENT_RESULT_MODE(state, mode) {
            state.documentResultMode = mode
        },
        UPDATE_DOCUMENT_INFO_CURRENT(state, documentInfo) {
            state.documentInfoCurrent = documentInfo
        }
    },
    actions: {
        updateDocumentResultMode({ commit }, mode) {
            commit('UPDATE_DOCUMENT_RESULT_MODE', mode)
        },
        updateDocumentInfoCurrent({ commit }, documentInfo) {
            commit('UPDATE_DOCUMENT_INFO_CURRENT', documentInfo)
        }
    },
    getters: {
        documentInfoCurrent: state => state.documentInfoCurrent,
        documentResultMode: state => state.documentResultMode
    }
}

export default documentResult
